import { render, staticRenderFns } from "./CollectionPointCreateModal.vue?vue&type=template&id=9a245e14"
import script from "./CollectionPointCreateModal.vue?vue&type=script&lang=js"
export * from "./CollectionPointCreateModal.vue?vue&type=script&lang=js"
import style0 from "./CollectionPointCreateModal.vue?vue&type=style&index=0&id=9a245e14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports